import BaseApiClient from '../BaseApiClient';
import { TeamMemberBusinessFunction } from '@interfaces/Team.interface';
import type {
  BusinessFunctionDestroyPayload,
  BusinessFunctionPayload
} from './types';

export type { BusinessFunctionDestroyPayload, BusinessFunctionPayload } from './types';

export class ApiBusinessFunctions extends BaseApiClient {
  async list(): Promise<TeamMemberBusinessFunction[]> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/business-functions?page[size]=9999&sort=order')
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async store(
    data: BusinessFunctionPayload
  ): Promise<TeamMemberBusinessFunction> {
    return new Promise((resolve, reject) => {
      this.client
        .post('/business-functions', data)
        .then((res) => {
          if (res.data) {
            resolve(res.data.data ?? res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async update(
    id: number | string,
    data: BusinessFunctionPayload
  ): Promise<TeamMemberBusinessFunction> {
    return new Promise((resolve, reject) => {
      this.client
        .put(`/business-functions/${id}`, data)
        .then((res) => {
          if (res.data) {
            resolve(res.data.data ?? res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async destroy(
    id: number | string,
    data?: BusinessFunctionDestroyPayload
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      this.client
        .delete(`/business-functions/${id}`, { data })
        .then((res) => {
          if (res.status === 204) {
            resolve();
          } else {
            reject('Invalid response');
          }
        })
        .catch(reject);
    });
  }
}

export { businessFunctionsQueryKeys } from './query-keys';
export { useBusinessFunctionsListQuery } from './use-business-functions-queries';
export {
  useBusinessFunctionsStoreMutation,
  useBusinessFunctionsUpdateMutation,
  useBusinessFunctionsDestroyMutation
} from './use-business-functions-mutations';
export type {
  BusinessFunctionsUpdateVariables,
  BusinessFunctionsDestroyVariables
} from './use-business-functions-mutations';
